import { IReferenceType, IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'

import { Enums } from '../common/'
import { OpDistributor } from './op-distributor'
import { OpDescr } from './op-descr'


export class OpActorGroup implements IReferenceType, IOpChangeState, IJsonSerializable, ICopyable<OpActorGroup> {

    // #region Properties

    public idActorGroup: number
    public name: string
    public builtIn: boolean
    public idDescr: number
    public idDistirbutor: number

    // #endregion


    // #region NavigationProperties

    public descr: OpDescr
    public distributor: OpDistributor

    // #endregion


    // #region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpActorGroup) {
            this.copy(<OpActorGroup>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    //IOpChangeState implementation

    public opState: Enums.OpChangeState

    //IOpChangeState implementation end


    //IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdActorGroup
    }

    public getReferenceKey(): number {
        return this.idActorGroup
    }

    public getReferenceValue(): any {
        return this
    }

    //IReferenceType implementation end


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpActorGroup {
        const actorGroup: OpActorGroup = new OpActorGroup(null)

        actorGroup.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return actorGroup
    }

    public copy(source: OpActorGroup, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }
        if (includeNavigationProperties) {
            if (source.descr != null) {
                this.descr = source.descr // TODO
            }
            if (source.distributor != null) {
                this.distributor = source.distributor.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idActorGroup = source.idActorGroup
        this.name = source.name
        this.builtIn = source.builtIn
        this.idDescr = source.idDescr
        this.idDistirbutor = source.idDistirbutor
        this.opState = source.opState
    }

    // #endregion


    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idActorGroup = opObj.ID_ACTOR_GROUP
            this.name = opObj.NAME
            this.builtIn = opObj.BUILT_IN
            this.idDescr = opObj.ID_DESCR
            this.idDistirbutor = opObj.ID_DISTRIBUTOR

            this.opState = opObj.OpState

            if (opObj._Descr) {
                this.descr = new OpDescr(opObj._Descr)
            }

            if (opObj._Distributor) {
                this.distributor = new OpDistributor(opObj._Distributor)
            }
        } else {
            this.idActorGroup = 0

            this.opState = Enums.OpChangeState.New
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ACTOR_GROUP: this.idActorGroup,
            OpState: this.opState
        }
    }

    // #endregion

    public toString() {
        return this.name;
    }

}